import React, { useEffect, useState, useCallback, useRef } from "react";
import { 
  CreateTable,
  SuccessMessage,
  FailMessage,
  Loading,
  DocumentTypeSelectWithAll,
  VendorSelect, CustomerSelect,
  FormatValueToDecimal
} from "../../common/APICommon";
import { apiUrl } from "../../utils/Configuration";
import { JournalHeader,
  JournalLines
} from "../Journals/JournalHeader";
import NoAccess from "../NoAccess";
import axios from 'axios';
import { motion, AnimatePresence } from "framer-motion";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ArticleIcon from '@mui/icons-material/Article';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';

const AP_DOCUMENT_TYPE = 1
const AR_DOCUMENT_TYPE = 2
const GJ_DOCUMENT_TYPE = 3

export default function Journals({type}) {
//#region Others
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [search, setSearch] = useState("");

  const handleSearch = (value) => {
    setSearch(value);
    setCurrentPage(1)
    const lowerValue = value.toLowerCase();

    const filtered = filteredData.filter(
      (item) =>
        item.documentHeaderText.toLowerCase().includes(lowerValue) ||
        item.documentNumber.toLowerCase().includes(lowerValue) 
    );

    setData(filtered);
  };
//#endregion






//#region Filters
  const [showFilterForm, setShowFilterForm] = useState(false);
  const [customerFilter, setCustomerFilter] = useState(null);
  const [vendorFilter, setVendorFilter] = useState(null);
  const [documentTypeFilter, setDocumentTypeFilter] = useState(null);
  const openFilterForm = () => {
    setShowFilterForm(true);
  }
  const closeFilterForm = () => {
    setShowFilterForm(false);
  }
//#endregion







//#region Variables
  const [selectedData, setSelectedData] = useState(null);
  const [journalLines, setJournalLines] = useState([])
  const [documentNumber, setDocumentNumber] = useState("") 
  const [vendor, setVendor] = useState(null) 
  const [customer, setCustomer] = useState(null)
  const [documentType, setDocumentType] = useState(null)
  const [documentDate, setDocumentDate] = useState(null)
  const [postingDate, setPostingDate] = useState(null)
  const [fiscalYear, setFiscalYear] = useState("")
  const [fiscalPeriod, setFiscalPeriod] = useState("")
  const [currency, setCurrency] = useState("PHP")
  const [referenceNumber, setReferenceNumber] = useState("")
  const [documentHeaderText, setDocumentHeaderText] = useState("")

  const resetVariables = () => {
    setJournalLines([])
    setDocumentNumber("")
    setVendor(null)
    setCustomer(null)
    setDocumentType(null)
    setDocumentDate(null)
    setPostingDate(null)
    setFiscalYear("")
    setFiscalPeriod("")
    setCurrency("PHP")
    setReferenceNumber("")
    setDocumentHeaderText("")
    setSelectedData(null);
  }

  const fetchDataById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);
//#endregion




// #region Add function
  const [showAddForm, setShowAddForm] = useState(false);
  
  const openAddForm = () => {
    setShowAddForm(true);
  }
  const closeAddForm = () => {
    setShowAddForm(false);
    resetVariables();
  }
//#endregion




// #region View function
  const [showViewForm, setShowViewForm] = useState(false);
  
  const openViewForm = () => {
    setShowViewForm(true);
  }
  const closeViewForm = () => {
    setShowViewForm(false);
    resetVariables();
  }

  const viewHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setJournalLines(_data?.journalLines ?? [])
    setDocumentNumber(_data?.documentNumber ?? "") 
    setVendor(_data?.vendor ?? null) 
    setCustomer(_data?.customer ?? null)
    setDocumentType(_data?.documentType ?? null)
    setDocumentDate(_data?.documentDate ?? null)
    setPostingDate(_data?.postingDate ?? null)
    setFiscalYear(_data?.fiscalYear ?? "")
    setFiscalPeriod(_data?.fiscalPeriod ?? "")
    setCurrency(_data?.currency ?? "")
    setReferenceNumber(_data?.referenceNumber ?? "")
    setDocumentHeaderText(_data?.documentHeaderText ?? "")

    setLoading(false)
    openViewForm();
  }
//#endregion






// #region View Lines function
  const [showViewLinesForm, setShowViewLinesForm] = useState(false);
  
  const openViewLinesForm = () => {
    setShowViewLinesForm(true);
  }
  const closeViewLinesForm = () => {
    setShowViewLinesForm(false);
    resetVariables();
  }

  const viewLinesHandleClick = async (data) => {
    setLoading(true);

    const _data = await fetchDataById(data);
    setSelectedData(_data);

    setLoading(false)
    openViewLinesForm();
  }
//#endregion






//#region Table data
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);

  const headers = [
    // 'ID', 
    'DOCUMENT #', 
    // 'DOCUMENT TYPE', 
    'HEADER TEXT', 
    'REFERENCE #', 
    // 'DOCUMENT DATE', 
    'LINE ITEM/S', 
    'POST DATE', 
    'VENDOR / CUSTOMER', 
    'AMOUNT', 
    'ACTIONS',
  ]
  const accessors = [
    // 'id', 
    'documentNumber', 
    // 'documentTypeDescription', 
    'documentHeaderText', 
    'referenceNumber', 
    // 'documentDate', 
    'journalLines', 
    'postingDate', 
    'company', 
    'amount', 
    'actions'
  ]

  const actions = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleClick,
      visible: true,
    },
    { 
      name: "View Lines", 
      tooltip: "view lines",
      icon: <ArticleIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewLinesHandleClick,
      visible: false,
    },
  ];

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      // const response = await axios.get(`${apiUrl}/api/Journal/vendor/${vendorFilter?.vendorId ?? "All"}/customer/${customerFilter?.customerId ?? "All"}/document-type/${documentTypeFilter ? documentTypeFilter?.id : 0}` , {
      const response = await axios.get(`${apiUrl}/api/Journal/vendor/${vendorFilter?.vendorId ?? "All"}/customer/${customerFilter?.customerId ?? "All"}/document-type/${type === "AP" ? AP_DOCUMENT_TYPE : type === "AR" ? AR_DOCUMENT_TYPE : GJ_DOCUMENT_TYPE}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      setData(response.data)
      setFilteredData(response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [vendorFilter, customerFilter, type]);

  useEffect(() => {
    fetchData();
  }, [fetchData])
//#endregion




//#region Access Template
  const accountData = JSON.parse(localStorage.getItem("accountData"));
  
  if (!accountData?.accessTemplate?.hasJournals) {
    return <NoAccess />;
  }
//#endregion





//#region UI
  return (
    <>
      <div className="p-6 bg-gray-50 min-h-screen">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-8 gap-4">
          { type === "GJ" &&
            <div>
              <h2 className="text-3xl font-bold text-gray-800 flex items-center gap-2">
                <ArticleIcon fontSize="large" className="text-theme-color" />
                {`Journals (${data?.length ?? 0})`}
              </h2>
              <p className="text-gray-500 mt-1">Record of a financial transaction.</p>
            </div>
          }
          { type === "GJ" &&
            <div className="flex gap-3">
              <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
                onClick={openFilterForm}
              >
                <FilterAltIcon/> Filter
              </button>
              <button onClick={openAddForm} className="flex items-center gap-2 bg-theme-color text-white px-4 py-2 rounded-lg text-sm font-semibold hover:bg-theme-color-h transition shadow-md">
                <AddCircleOutlineIcon fontSize="small" /> New Entry
              </button>
            </div>
          }
        </div>

        {/* Search and Filters */}
        { type === "GJ" ?
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <div className="mb-4 w-full">
              <input
                type="text"
                placeholder="Search by document number or header..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
          </div>
          :
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <div className="mb-4 w-full">
              <input
                type="text"
                placeholder="Search by document number or header..."
                className="px-4 py-2 border rounded-lg w-full md:w-2/3 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color"
                value={search}
                onChange={(e) => handleSearch(e.target.value)}
              />
              {/* Add filter dropdowns here if needed */}
            </div>
            <button className="bg-white border border-gray-300 text-theme-color hover:bg-gray-100 px-3 py-1 rounded-md flex items-center gap-2 hover:bg-opacity-90 transition"
              onClick={openFilterForm}
            >
              <FilterAltIcon/> Filter
            </button>
          </div>
        }

        <CreateTable
          tableName={"Journals"}
          headers={headers}
          accessors={accessors}
          data={data}
          actions={actions}

          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          itemsPerPage={10}
          totalItems={data?.length}
        />
      </div>

      <CreateJournalModal 
        visible={showAddForm}
        onClose={closeAddForm}
        // onSave={handleUpdateData}
        modalName={"Create Journal"}
        isEditable={true}
        data={selectedData}
        fetchData={fetchData}
      />

      <JournalViewModal 
        visible={showViewForm}
        onClose={closeViewForm}
        // onSave={handleUpdateData}
        modalName={selectedData?.documentTypeDescription}
        data={selectedData}

        documentNumber={documentNumber} setDocumentNumber={setDocumentNumber}
        journalLines={journalLines} setJournalLines={setJournalLines}
        vendor={vendor} setVendor={setVendor}
        customer={customer} setCustomer={setCustomer}
        documentType={documentType} setDocumentType={setDocumentType}
        documentDate={documentDate} setDocumentDate={setDocumentDate}
        postingDate={postingDate} setPostingDate={setPostingDate}
        fiscalYear={fiscalYear} setFiscalYear={setFiscalYear}
        fiscalPeriod={fiscalPeriod} setFiscalPeriod={setFiscalPeriod}
        currency={currency} setCurrency={setCurrency}
        referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
        documentHeaderText={documentHeaderText} setDocumentHeaderText={setDocumentHeaderText}
      />

      <ViewJournalLinesModal
        visible={showViewLinesForm} 
        onClose={closeViewLinesForm} 
        // onSave={}
        modalName={"View Journal Line"}
        data={selectedData}
        journalLines={journalLines} setJournalLines={setJournalLines}
        isEditable={false}
      />

      <FilterModal 
        visible={showFilterForm}
        onClose={closeFilterForm}
        modalName={"Filter"}

        customerFilter={customerFilter} setCustomerFilter={setCustomerFilter}
        vendorFilter={vendorFilter} setVendorFilter={setVendorFilter}
        documentTypeFilter={documentTypeFilter} setDocumentTypeFilter={setDocumentTypeFilter}
      />

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
//#endregion
}







//#region Journal
const CreateJournalModal = ({
  visible, onClose, onSave, modalName,
  data, fetchData,
  isEditable,
}) => {
  const [successMessage, setSuccessMessage] = useState("");
  const [failMessage, setFailMessage] = useState("");
  const [loading, setLoading] = useState(false)
  const [journalLines, setJournalLines] = useState([])
  const [documentNumber, setDocumentNumber] = useState("") 
  const [vendor, setVendor] = useState(null) 
  const [customer, setCustomer] = useState(null)
  const [documentType, setDocumentType] = useState(null)
  const [documentDate, setDocumentDate] = useState(null)
  const today = new Date().toISOString().split("T")[0];
  const [postingDate, setPostingDate] = useState(today)
  const [fiscalYear, setFiscalYear] = useState("")
  const [fiscalPeriod, setFiscalPeriod] = useState("")
  const [currency, setCurrency] = useState("PHP")
  const [referenceNumber, setReferenceNumber] = useState("")
  const [documentHeaderText, setDocumentHeaderText] = useState("")

  const generateNumber = useCallback(async () => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/generate-number` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return ""
    }
  }, []);

  const fetchNumber = useCallback(async () => {
    setLoading(true)

    const _number = await generateNumber();
    setDocumentNumber(_number?.number)

    setLoading(false)
  }, [generateNumber])

  useEffect(() => {
    if (visible && !documentNumber) {
      fetchNumber()
      setVendor(data?.vendor ?? null)
      setCustomer(data?.customer ?? null)

      const _documentType = {
        id: 3,
        description: "General Journal",
        isActive: true
      }

      setDocumentType(_documentType)
      setDocumentDate(data?.documentDate)
      setReferenceNumber(data?.documentNumber)
    }
  }, [visible, documentNumber, fetchNumber, data])

  const accountData = JSON.parse(localStorage.getItem("accountData"));

  const handleAddData = async () => {
    const data = {
      journalLines: journalLines,
      vendorId: vendor?.vendorId,
      customerId: customer?.customerId,
      documentNumber: documentNumber,
      documentTypeId: documentType?.id,
      documentSubType: "GJ",
      documentDate: documentDate,
      postingDate: postingDate,
      fiscalYear: fiscalYear,
      fiscalPeriod: fiscalPeriod,
      currency: currency,
      referenceNumber: referenceNumber,
      documentHeaderText: documentHeaderText,
      createdDate: new Date(),
      createdBy: accountData?.id,
    };

    try {
      setLoading(true);

      await axios.post(`${apiUrl}/api/Journal`, data, {
          headers: { 'Content-Type': 'application/json' }
      });
      
      await fetchData();
      setSuccessMessage("Data added successfully!");
    } catch (error) {
      console.error('There was a problem adding data:', error);
      const errorMessage = JSON.parse(error.response.request.responseText).message;
      setFailMessage(`Failed to add data: ${errorMessage}`);
    } finally {
      setLoading(false);
    }
  } 

  const handleSubmit = async () => {
    if(!documentNumber
      || !documentType
      || !postingDate
      || !currency
      || journalLines.length <= 0
    ){
      setFailMessage("Please fill up all required fields.")
      return;
    }

    await handleAddData();
    closeModal();
  };

  const resetLocalVariables = () => {
    setJournalLines([])
    setDocumentNumber("")
    setVendor(null)
    setCustomer(null)
    setDocumentType(null)
    setDocumentDate(null)
    setPostingDate(today)
    setFiscalYear("")
    setFiscalPeriod("")
    setCurrency("PHP")
    setReferenceNumber("")
    setDocumentHeaderText("")
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{`${modalName}`}</h2>
                <p className="text-sm text-gray-500">{`Document Number: ${documentNumber}`}</p>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <JournalHeader 
                type={"GJ"}
                isEditable={true}
                documentNumber={documentNumber} setDocumentNumber={setDocumentNumber}
                journalLines={journalLines} setJournalLines={setJournalLines}
                vendor={vendor} setVendor={setVendor}
                customer={customer} setCustomer={setCustomer}
                documentType={documentType} setDocumentType={setDocumentType}
                documentDate={documentDate} setDocumentDate={setDocumentDate}
                postingDate={postingDate} setPostingDate={setPostingDate}
                fiscalYear={fiscalYear} setFiscalYear={setFiscalYear}
                fiscalPeriod={fiscalPeriod} setFiscalPeriod={setFiscalPeriod}
                currency={currency} setCurrency={setCurrency}
                referenceNumber={referenceNumber} setReferenceNumber={setReferenceNumber}
                documentHeaderText={documentHeaderText} setDocumentHeaderText={setDocumentHeaderText}
              />
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
              {isEditable &&
                <button
                  onClick={handleSubmit}
                  className="px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold hover:opacity-90 shadow-lg shadow-theme-color/20 transition active:scale-95 text-sm"
                >
                  Create Journal
                </button>
              }
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <div className="fixed top-5 right-5 z-50 flex flex-col space-y-2">
        <SuccessMessage message={successMessage} onClose={() => setSuccessMessage("")} />
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>

      { loading && <Loading />}
    </>
  );
};
const JournalViewModal = ({ 
  visible, onClose, modalName,
  data,
  journalLines, setJournalLines, // Setters included as requested, though usually used for editing
  documentNumber, setDocumentNumber,
  vendor, setVendor,
  customer, setCustomer,
  documentType, setDocumentType,
  documentDate, setDocumentDate,
  postingDate, setPostingDate,
  fiscalYear, setFiscalYear,
  fiscalPeriod, setFiscalPeriod,
  currency, setCurrency,
  referenceNumber, setReferenceNumber,
  documentHeaderText, setDocumentHeaderText,
  // Add audit fields if available in your state, otherwise they default to 'N/A'
  createdBy, createdDate, updatedBy, updatedDate 
}) => {
  const printRef = useRef();
  const [isDownloading, setIsDownloading] = useState(false);
  const getCurrency = JSON.parse(localStorage.getItem("currency") || '{"symbol": "$"}');

  // Helper for currency formatting
  const formatVal = (num) => {
    return Number(num || 0).toLocaleString(undefined, { 
      minimumFractionDigits: 2, 
      maximumFractionDigits: 2 
    });
  };

  const downloadHandleClick = async () => {
    const element = printRef.current;
    if (!element) return;
    setIsDownloading(true);
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
      });
      const imgData = canvas.toDataURL('image/png');
      const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Journal_${documentNumber || 'Export'}.pdf`);
    } catch (error) {
      console.error("PDF Generation Error:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  const mainData = journalLines?.filter(i => i.lineRole !== "Item")

  if (!visible) return null;

  // Calculate Totals based on the journalLines parameter
  // const totalDebit = journalLines?.reduce((sum, line) => 
  //   line.postingKeyDebitCredit === "Debit" || line.postingKeyDebitCredit === "S" ? sum + line.amount : sum, 0);
  // const totalCredit = journalLines?.reduce((sum, line) => 
  //   line.postingKeyDebitCredit === "Credit" || line.postingKeyDebitCredit === "H" ? sum + line.amount : sum, 0);

  // Determine Entity Name (Vendor or Customer or General)
  const entityName = vendor?.name1 || vendor?.name1 || customer?.name1 || customer?.name1 || "General Ledger";
  const entityId = vendor?.vendorId || vendor?.vendorId || customer?.customerId || customer?.customerId || "N/A";

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
      >
        <motion.div
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.95, opacity: 0, y: 20 }}
          className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[95vh]"
        >
          {/* Header */}
          <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{modalName}</h2>
              <p className="text-sm text-gray-500">Document Type: {documentType?.description || documentType || 'N/A'}</p>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Body */}
          <div className="p-8 overflow-y-auto custom-scrollbar bg-gray-100">
            <div ref={printRef} className="max-w-5xl mx-auto bg-white shadow-xl border border-gray-200 rounded-sm p-10 min-h-[842px] flex flex-col">
              
              {/* 1. TOP HEADER SECTION */}
              <div className="flex justify-between items-start border-b-4 border-theme-color pb-6 mb-8">
                <div>
                  <h1 className="text-4xl font-black text-theme-color tracking-tighter mb-1">{modalName}</h1>
                  <div className="grid grid-cols-2 gap-x-6 gap-y-1 mt-4">
                    <div>
                      <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block">Reference</span>
                      <span className="text-sm font-bold text-gray-700">{referenceNumber || "---"}</span>
                    </div>
                    <div>
                      <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest block">Currency</span>
                      <span className="text-sm font-bold text-gray-700">{currency || getCurrency.symbol}</span>
                    </div>
                  </div>
                </div>
                <div className="text-right">
                  <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Document Number</p>
                  <p className="text-2xl font-mono font-bold text-gray-900">#{documentNumber || 'DRAFT'}</p>
                  
                  <div className="flex gap-6 mt-4 justify-end">
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest text-right">Doc Date</p>
                      <p className="text-sm font-bold text-gray-800">{documentDate ? new Date(documentDate).toLocaleDateString() : 'N/A'}</p>
                    </div>
                    <div>
                      <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest text-right">Posting Date</p>
                      <p className="text-sm font-bold text-gray-800">{postingDate ? new Date(postingDate).toLocaleDateString() : 'N/A'}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* 2. ENTITY & PERIOD INFO */}
              <div className="grid grid-cols-3 gap-6 mb-8 p-4 bg-gray-50 rounded-xl border border-gray-100">
                <div>
                  <h3 className="text-[10px] font-black text-theme-color uppercase tracking-widest mb-2">Accountable Entity</h3>
                  <p className="font-bold text-gray-900 leading-tight">{entityName}</p>
                  <p className="text-xs text-gray-500">ID: {entityId}</p>
                </div>
                <div>
                  <h3 className="text-[10px] font-black text-theme-color uppercase tracking-widest mb-2">Fiscal Period</h3>
                  <p className="font-bold text-gray-900">Period {fiscalPeriod || '--'}</p>
                  <p className="text-xs text-gray-500">Fiscal Year {fiscalYear || '--'}</p>
                </div>
                <div>
                  <h3 className="text-[10px] font-black text-theme-color uppercase tracking-widest mb-2">Document Header Text</h3>
                  <p className="text-sm text-gray-700 italic leading-relaxed">{documentHeaderText || "No additional notes provided."}</p>
                </div>
              </div>

              {/* 3. JOURNAL LINES TABLE */}
              <div className="flex-grow">
                <table className="w-full text-left border-collapse">
                  <thead>
                    <tr className="border-b-2 border-gray-900">
                      <th className="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400 w-12 text-center">PK</th>
                      <th className="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">Account / Description</th>
                      <th className="py-3 text-[10px] font-bold uppercase tracking-widest text-gray-400">Business Area</th>
                      <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-900 w-32">Debit ({currency})</th>
                      <th className="py-3 text-right text-[10px] font-bold uppercase tracking-widest text-gray-900 w-32">Credit ({currency})</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-100">
                    {mainData?.length > 0 ? (
                        mainData.map((line, idx) => {
                        const isDebit = line.postingKeyDebitCredit === "Debit" || line.postingKeyDebitCredit === "S";
                        return (
                            <tr key={idx} className="hover:bg-gray-50/50">
                            <td className="py-4 text-xs font-mono text-gray-500 text-center">{line.postingKeyCode}</td>
                            <td className="py-4">
                                <p className="text-sm font-bold text-gray-800">{line.glAccountNumber || line.glAccountNumber}</p>
                                <p className="text-xs text-gray-500">{line.glAccountName || line.glAccountName}</p>
                                {line.ItemText && <p className="text-[10px] text-blue-600 mt-1 uppercase font-semibold">{line.itemText}</p>}
                            </td>
                            <td className="py-4 text-sm text-gray-600">
                                {line.businessAreaDescription || line.businessAreaDescription || "---"}
                            </td>
                            <td className="py-4 text-right text-sm font-bold text-gray-900">
                                {isDebit ? `${line.lineRole === "Main" || line.lineRole === "VAT" ? "" : ""} ${formatVal(line.amount)}` : ""}
                            </td>
                            <td className="py-4 text-right text-sm font-bold text-gray-900">
                                {!isDebit ? `${line.lineRole === "Main" || line.lineRole === "VAT" ? "" : ""} ${formatVal(line.amount)}` : ""}
                            </td>
                            </tr>
                        );
                        })
                    ) : (
                        <tr>
                            <td colSpan="5" className="py-12 text-center text-gray-400 italic text-sm">No lines available for this document</td>
                        </tr>
                    )}
                  </tbody>
                  <tfoot>
                    <tr className="border-t-2 border-gray-900 bg-gray-50">
                      <td colSpan="3" className="py-4 text-right font-black text-[10px] uppercase tracking-[0.2em] px-4">Totals</td>
                      <td className="py-4 text-right text-sm font-black text-gray-900 border-l border-gray-200">
                        {/* <div className="border-b m-2">
                          {data?.journalLines?.filter(i => i.postingKeyDebitCredit === "Debit")?.map((item, index) => {
                            return (
                              <div key={index}>
                                <p className={`text-xs font-medium text-gray-500 uppercase tracking-wider`}>{`${item.lineRole === "Main" || item.lineRole === "VAT" ? "+" : "-"} ${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(item.amount)}`}</p>
                              </div>
                            )
                          })}
                        </div> */}
                        <p>{formatVal(data.totalDebitAmount)}</p>
                      </td>
                      <td className="py-4 text-right text-sm font-black text-gray-900 border-l border-gray-200">
                        {/* <div className="border-b m-2">
                          {data?.journalLines?.filter(i => i.postingKeyDebitCredit === "Credit")?.map((item, index) => {
                            return (
                              <div key={index}>
                                <p className={`text-xs font-medium text-gray-500 uppercase tracking-wider`}>{`${item.lineRole === "Main" || item.lineRole === "VAT" ? "+" : "-"} ${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(item.amount)}`}</p>
                              </div>
                            )
                          })}
                        </div> */}
                        <p>{formatVal(data.totalCreditAmount)}</p>
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

            </div>
          </div>

          {/* Footer Buttons */}
          <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
            <button onClick={onClose} className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm">
              Close
            </button>
            <button
              onClick={downloadHandleClick}
              disabled={isDownloading}
              className={`px-10 py-2.5 rounded-lg bg-theme-color text-white font-bold shadow-lg transition active:scale-95 text-sm flex items-center gap-2 ${isDownloading ? 'opacity-70 cursor-not-allowed' : 'hover:opacity-90'}`}
            >
              {isDownloading ? (
                <>
                  <svg className="animate-spin h-4 w-4 text-white" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                  Processing...
                </>
              ) : 'Download PDF'}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};
//#endregion







//#region Journal Line
const ViewJournalLinesModal = ({
  visible, onClose, onSave, modalName,
  data,
}) => {
  const getCurrency = JSON.parse(localStorage.getItem("currency") || "{}");
  const [loading, setLoading] = useState(false)
  const [selectedJournalLine, setSelectedJournalLine] = useState(null);
  const [currentPageJournalLine, setCurrentPageJournalLine] = useState(1);
  
  const headersJournalLine = [
    // 'POSTING KEY', 
    'ACCOUNT NAME', 
    'DEBIT', 
    'CREDIT', 
    'ITEM TEXT', 
    // 'BUSINESS AREA', 
    'ACTIONS'
  ]
  const accessorsJournalLine = [
    // 'postingKey', 
    'glAccountName', 
    'debit', 
    'credit',  
    'itemText', 
    // 'businessAreaDescription', 
    'actions'
  ]

  const [showViewJournalLineForm, setShowViewJournalLineForm] = useState(false);
  const openViewJournalLineForm = () => {
    setShowViewJournalLineForm(true);
  }
  const closeViewJournalLineForm = () => {
    setShowViewJournalLineForm(false);
    setSelectedJournalLine(null)
  }

  const fetchDataLineById = useCallback(async (_data) => {
    try {
      const response = await axios.get(`${apiUrl}/api/Journal/journal-lines/${_data?.id}` , {
        headers: { 'Content-Type': 'application/json'}
      })
        
      return (response.data)
    } catch (error) {
      console.error('Error fetching data:', error);
      return null
    }
  }, []);

  const viewHandleJournalLineClick = async (_data) => {
    setLoading(true);
    const line = await fetchDataLineById(_data)
    setSelectedJournalLine(line)

    setLoading(false)
    openViewJournalLineForm();
  }

  const actionsJournalLine = [
    { 
      name: "View", 
      tooltip: "view",
      icon: <VisibilityIcon fontSize="small" />,
      className: "bg-sky-500 hover:bg-sky-600",
      function: viewHandleJournalLineClick,
      visible: true,
    },
  ];

  
  const resetLocalVariables = () => {
    setSelectedJournalLine(null);
    setCurrentPageJournalLine(1);
    setLoading(false);
  }

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  }

  const mainData = data?.journalLines?.filter(i => i.lineRole !== "Item")

  //New calculations
  // Helper to find amounts based on common item text keywords
  const getAmountByText = (lineRole) => {
    const line = data?.journalLines?.find(item => 
      item.lineRole === lineRole
    );
    return line ? line.amount : 0;
  };

  const vatableAmount = getAmountByText('Main');
  const vatAmount = getAmountByText('VAT');
  const discountAmount = getAmountByText('Discounts');
  const ewtAmount = getAmountByText('EWT');
  const subTotal = vatableAmount + vatAmount;
  // Total Amount is usually the Net Cash Paid
  const totalPaid = (subTotal - discountAmount);
  //

  console.log({data})

  if (!visible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.95, opacity: 0, y: 20 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.95, opacity: 0, y: 20 }}
            className="bg-gray-100 rounded-2xl shadow-2xl w-full max-w-7xl overflow-hidden flex flex-col max-h-[90vh]"
          >
            {/* Header */}
            <div className="px-8 py-5 bg-white border-b border-gray-200 flex justify-between items-center">
              <div>
                <h2 className="text-2xl font-bold text-gray-800 tracking-tight">{`${modalName}`}</h2>
              </div>
              <button onClick={closeModal} className="text-gray-400 hover:text-gray-600 transition p-2 hover:bg-gray-100 rounded-full">
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            {/* Body */}
            <div className="p-8 overflow-y-auto custom-scrollbar">
              <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
                <CreateTable
                  tableName={"Journal Line"}
                  headers={headersJournalLine}
                  accessors={accessorsJournalLine}
                  data={mainData ?? []}
                  actions={actionsJournalLine}
                  currentPage={currentPageJournalLine}
                  setCurrentPage={setCurrentPageJournalLine}
                  itemsPerPage={10}
                  totalItems={mainData?.length}
                />
              </div>

              <div className="mt-6 hidden grid-cols-1 md:grid-cols-2 gap-6">
                <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex justify-between items-center">
                  <div className="w-full">
                    {mainData?.filter(i => i.postingKeyDebitCredit === "Debit")?.map((item, index) => {
                      return (
                        <div key={index} className="flex flex-row justify-between">
                          <p className={`text-xs font-medium text-gray-500 uppercase tracking-wider`}>{`${item.itemText}`}</p>
                          <p className={`text-xs font-medium text-gray-500 uppercase tracking-wider`}>{`${item.lineRole === "Main" || item.lineRole === "VAT" ? "+" : "-"} ${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(item.amount)}`}</p>
                        </div>
                      )
                    })}
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wider mt-5">Total Net (Dr)</p>
                    <p className="text-2xl font-bold text-red-600 mt-1">{`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(data.totalDebitAmount)}`}</p>
                  </div>
                </div>

                <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm flex justify-between items-center">
                  <div className="w-full">
                    {mainData?.filter(i => i.postingKeyDebitCredit === "Credit")?.map((item, index) => {
                      return (
                        <div key={index} className="flex flex-row justify-between">
                          <p className={`text-xs font-medium text-gray-500 uppercase tracking-wider`}>{`${item.itemText}`}</p>
                          <p className={`text-xs font-medium text-gray-500 uppercase tracking-wider`}>{`${item.lineRole === "Main" || item.lineRole === "VAT" ? "+" : "-"} ${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(item.amount)}`}</p>
                        </div>
                      )
                    })}
                    <p className="text-sm font-medium text-gray-500 uppercase tracking-wider mt-5">Total Net (Cr)</p>
                    <p className="text-2xl font-bold text-emerald-600 mt-1">{`${getCurrency?.symbol ? getCurrency?.symbol : ""}${FormatValueToDecimal(data.totalCreditAmount)}`}</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex flex-col md:flex-row gap-6">
                {/* Left Side: Ledger Balance Check (Small/Clean) */}
                <div className="flex-1 bg-gray-50 p-6 rounded-xl border border-gray-200">
                  <h3 className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4">Ledger Verification</h3>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500">Total Debit</span>
                      <span className="text-sm font-semibold text-gray-700">{getCurrency?.symbol} {FormatValueToDecimal(data.totalDebitAmount)}</span>
                    </div>
                    <div className="flex justify-between items-center">
                      <span className="text-sm text-gray-500">Total Credit</span>
                      <span className="text-sm font-semibold text-gray-700">{getCurrency?.symbol} {FormatValueToDecimal(data.totalCreditAmount)}</span>
                    </div>
                    <div className="border-t border-gray-200 pt-2 flex justify-between">
                      <span className="text-xs font-bold text-emerald-600">Status</span>
                      <span className="text-xs font-bold text-emerald-600">BALANCED</span>
                    </div>
                  </div>
                </div>

                {/* Right Side: Financial Summary (The "Invoice" view) */}
                <div className="w-full md:w-96 bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                  <div className="space-y-3">
                    {/* EWT Section - Styled as a "Withholding" box */}
                    {ewtAmount > 0 && (
                      <div className="bg-blue-50/50 border border-blue-100 rounded-lg p-3 my-2">
                        <div className="flex justify-between items-center text-sm">
                          <div className="flex flex-col">
                            <span className="text-blue-600 font-bold text-[10px] uppercase">EWT Withheld</span>
                            <span className="text-[10px] text-blue-400 italic">To be remitted to BIR</span>
                          </div>
                          <span className="text-blue-600 font-bold">
                            ({getCurrency?.symbol} {FormatValueToDecimal(ewtAmount)})
                          </span>
                        </div>
                      </div>
                    )}

                    {/* Vatable & VAT */}
                    <div className="flex justify-between text-sm px-3">
                      <span className="text-gray-500">Vatable Amount</span>
                      <span className="text-gray-800 font-medium">{getCurrency?.symbol} {FormatValueToDecimal(vatableAmount)}</span>
                    </div>
                    <div className="flex justify-between text-sm px-3">
                      <span className="text-gray-500">VAT (12%)</span>
                      <span className="text-gray-800 font-medium">{getCurrency?.symbol} {FormatValueToDecimal(vatAmount)}</span>
                    </div>
                    
                    <div className="border-t border-gray-100 my-2 px-3"></div>

                    {/* Subtotal */}
                    <div className="flex justify-between text-sm px-3">
                      <span className="text-gray-900 font-bold">Subtotal</span>
                      <span className="text-gray-900 font-bold">{getCurrency?.symbol} {FormatValueToDecimal(subTotal)}</span>
                    </div>

                    {/* Discount */}
                    {discountAmount > 0 && (
                      <div className="flex justify-between text-sm px-3">
                        <span className="text-red-500">Discount</span>
                        <span className="text-red-500 font-medium">-{getCurrency?.symbol} {FormatValueToDecimal(discountAmount)}</span>
                      </div>
                    )}

                    <div className="border-t-2 border-gray-900 my-2 px-3"></div>

                    {/* Total Amount (Net Pay) */}
                    <div className="flex justify-between items-end px-3">
                      <div className="flex flex-col">
                        <span className="text-xs font-bold text-gray-400 uppercase">Total Net Amount</span>
                        <span className="text-[10px] text-gray-400 italic font-normal">(Subtotal - Disc)</span>
                      </div>
                      <span className="text-2xl font-black text-gray-900 tracking-tight">
                        {getCurrency?.symbol} {FormatValueToDecimal(data.totalCreditAmount - vatAmount - discountAmount - ewtAmount > 0 ? totalPaid : data.totalCreditAmount)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div className="px-8 py-6 border-t bg-white flex justify-end items-center space-x-4">
              <button
                onClick={closeModal}
                className="px-6 py-2.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-50 transition font-semibold text-sm"
              >
                Cancel
              </button>
            </div>
          </motion.div>
        </motion.div>
      </AnimatePresence>

      <JournalLines
        visible={showViewJournalLineForm} 
        onClose={closeViewJournalLineForm} 
        // onSave={}
        modalName={"View Journal Line"}
        data={selectedJournalLine}
        journalLines={mainData}
        isEditable={false}
      />
      
      { loading && <Loading />}
    </>
  );
};
//#endregion












//#region Filter
const FilterModal = ({
  visible, onClose, modalName,
  documentTypeFilter, setDocumentTypeFilter,
  customerFilter, setCustomerFilter,
  vendorFilter, setVendorFilter,
}) => {
  const [failMessage, setFailMessage] = useState("");
  const [_customerFilter, _setCustomerFilter] = useState(customerFilter);
  const [_vendorFilter, _setVendorFilter] = useState(vendorFilter);
  const [_documentTypeFilter, _setDocumentTypeFilter] = useState(documentTypeFilter);

  useEffect(() => {
    if(visible){
      _setCustomerFilter(customerFilter)
      _setVendorFilter(vendorFilter)
      _setDocumentTypeFilter(documentTypeFilter)
    }
  }, [visible, customerFilter, vendorFilter, documentTypeFilter])

  const handleSubmit = async () => {
    setCustomerFilter(_customerFilter);
    setVendorFilter(_vendorFilter);
    setDocumentTypeFilter(_documentTypeFilter);
    closeModal();
  };

  const resetLocalVariables = () => {
    setFailMessage("");
  };

  const closeModal = () => {
    onClose();
    resetLocalVariables();
  };

//#region Customer
  const [showCustomerSelectForm, setShowCustomerSelectForm] = useState(false);
  const openCustomerSelectForm = () => {
    setShowCustomerSelectForm(true);
  }
  const closeCustomerSelectForm = () => {
    setShowCustomerSelectForm(false);
  }
//#endregion



//#region Vendor
  const [showVendorSelectForm, setShowVendorSelectForm] = useState(false);
  const openVendorSelectForm = () => {
    setShowVendorSelectForm(true);
  }
  const closeVendorSelectForm = () => {
    setShowVendorSelectForm(false);
  }
//#endregion

  if (!visible) return null;

  return (
    <>
      {/* Background overlay */}
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-gray-200 bg-opacity-70 flex items-center justify-center z-50"
          >
            {/* Modal container */}
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              transition={{ duration: 0.2 }}
              className="bg-gray-100 rounded-2xl shadow-lg w-full max-w-lg p-8"
            >
              <h2 className="text-2xl font-semibold border-b pb-3 mb-6">
                {modalName}
              </h2>

              <div className="space-y-5 max-h-[500px] overflow-y-auto short:max-h-[300px] medium:h-[400px] pr-1">
                <div className="hidden">
                  <label className="block text-sm font-medium mb-1 text-gray-700">
                    Document Type
                  </label>
                  <DocumentTypeSelectWithAll data={_documentTypeFilter} setData={_setDocumentTypeFilter} isEditable={true}/>
                </div>
                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Vendor <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Vendor"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_vendorFilter ? `${_vendorFilter?.vendorId} - ${_vendorFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_vendorFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openVendorSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setVendorFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-semibold mb-1 text-gray-700">
                    Customer <span className="text-red-500">*</span>
                  </label>
                  <div className="flex flex-row items-center">
                    <input
                      type="text"
                      placeholder="Select Customer"
                      className="w-full border border-gray-300 text-sm rounded-l-lg px-3 py-2 text-gray-800 focus:outline-none focus:ring-2 focus:ring-theme-color focus:border-theme-color transition"
                      value={`${_customerFilter ? `${_customerFilter?.customerId} - ${_customerFilter?.name1}` : ""}`}
                      readOnly
                    />
                    {!_customerFilter ?
                      <button className="bg-theme-color hover:bg-theme-color-h p-[5px] rounded-r-lg" onClick={openCustomerSelectForm}>
                        <PersonSearchIcon className="text-white"/>
                      </button> 
                      :
                      <button className="bg-red-400 hover:bg-red-500 p-[5px] rounded-r-lg" onClick={()=>_setCustomerFilter(null)}>
                        <RemoveCircleIcon className="text-white"/>
                      </button>
                    }
                  </div>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex justify-end space-x-3 mt-8 border-t pt-4">
                <button
                  onClick={closeModal}
                  className="px-5 py-2 rounded-lg border border-gray-300 text-gray-700 hover:bg-gray-100 transition"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="px-5 py-2 rounded-lg bg-theme-color text-white font-medium hover:opacity-90 transition"
                >
                  Save
                </button>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>

      <CustomerSelect 
        visible={showCustomerSelectForm} 
        onClose={closeCustomerSelectForm}
        modalName={"Select Customer"}
        data={_customerFilter} setData={_setCustomerFilter}
      />

      <VendorSelect 
        visible={showVendorSelectForm} 
        onClose={closeVendorSelectForm}
        modalName={"Select Vendor"}
        data={_vendorFilter} setData={_setVendorFilter}
      />

      {/* Alert */}
      <div className="fixed top-5 right-5 z-[9999] flex flex-col space-y-2">
        <FailMessage message={failMessage} onClose={() => setFailMessage("")} />
      </div>
    </>
  );
};
//#endregion